'use client';

import React, { createContext, useContext, useState } from 'react';
interface Video {
  url: string;
  title: string;
  id: string;
}
interface VideoContextType {
  setVideo: (video: Video | null) => void;
  video: Video | null;
}
const VideoContext = createContext<VideoContextType | undefined>(undefined);
export function VideoProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [video, setVideo] = useState<Video | null>(null);
  return <VideoContext value={{
    video,
    setVideo
  }} data-sentry-element="VideoContext" data-sentry-component="VideoProvider" data-sentry-source-file="video-player-provider.tsx">
      {children}
    </VideoContext>;
}
;
export const useVideo = () => {
  const context = useContext(VideoContext);
  if (!context) {
    throw new Error('useVideo must be used within a VideoProvider');
  }
  return context;
};